import { Controller } from "@hotwired/stimulus"

// Groups a French phone number by pairs as it is typed ("06 14 25 36 47",
// "+33 6 14 25 36 47"). Anything else (foreign numbers, extra digits, another
// country picked on the flag) is left as typed. The server normalizes the
// number, spaces included.
export default class extends Controller {
  connect () {
    this.format()
  }

  format () {
    const country = this.element.dataset.phoneCountry
    if (country && country !== "FR") return

    const formatted = formatFrenchPhone(this.element.value)
    if (formatted === null || formatted === this.element.value) return

    const atEnd = this.element.selectionStart === this.element.value.length
    this.element.value = formatted
    if (atEnd) this.element.setSelectionRange(formatted.length, formatted.length)
  }
}

export function formatFrenchPhone (value) {
  const international = value.trim().startsWith("+33")
  const digits = value.replace(/\D/g, "").replace(/^33/, international ? "" : "33")

  if (international) {
    if (digits.length > 9) return null

    return ["+33", digits.slice(0, 1), ...pairs(digits.slice(1))].filter(Boolean).join(" ")
  }
  if (!digits.startsWith("0") || digits.length > 10) return null

  return pairs(digits).join(" ")
}

function pairs (digits) {
  return digits.match(/.{1,2}/g) || []
}
